import React, { useState, useRef } from "react";

import { modifyPdf } from "../helper/PdfHelper";
import "./App.css";

const oenRegex = new RegExp('^[0-9]{9}$');


function FileUploader() {

 const canvasRef = useRef(null)

  const [oen, setOen] = useState("");
  const [error, setError] = useState("");
  const [printDate, setPrintDate] = useState("");
  const [status, setStatus] = useState("");

  const [selectedFile, setSelectedFile] = useState();
  const [fileBinary, setFileBinary] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [uuidValue, setUuidValue] = useState("");

  const changeHandler = (event) => {
    console.log(event.target.files[0]);
    setSelectedFile(event.target.files[0]);
    var reader = new FileReader();
    reader.onload = function () {
      var arrayBuffer = this.result,
        array = new Uint8Array(arrayBuffer);

      setFileBinary(array);
    };
    reader.readAsArrayBuffer(event.target.files[0]);

    setIsFilePicked(true);
  };

  return (
      <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" id="form1">
      <canvas ref={canvasRef} style={{
        "display": "none"
      }} />
      <label for="oen" class="form-label inline-block mb-2 text-gray-700">
        Upload transcript information in the database. (Note: if an OEN previously had a validation code, this will overwrite the current validation code)
      </label>
        <div class="mb-3 w-96">
          <label for="oen" class="form-label inline-block mb-2 text-gray-700">
            OEN
          </label>
          <input
            class="shadow appearance-none border rounded mb-5 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="oen"
            type="text"
            placeholder="OEN"
            maxLength={9}
            onChange={(e) => {
              setOen(e.target.value);
            }}
          />
          <div>
          <label for="printDate" class="form-label inline-block mb-2 text-gray-700">
            Print Date
          </label>
          <input
            class="shadow appearance-none border rounded mb-5 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="printDate"
            type="date"
            onChange={(e) => {
              console.log(e.target.value);
              setPrintDate(e.target.value);
            }}
          />
          </div>

          <input
            class="form-control
                block
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                text-gray-700
                bg-white bg-clip-padding
                border border-solid border-gray-300
                rounded
                transition
                ease-in-out
                m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            type="file"
            accept=".pdf"
            id="formFile"
            onChange={changeHandler}
          />
        </div>

        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          type="button"
          form="form1"
          onClick={async (e) => {
            setError("");

            if(!oenRegex.test(oen)) {
              setError("Incorrect OEN format. Must be exactly 9 digits.");
              return;
            }

            if (!oen) {
              setError("No OEN filled");
            } else if (!isFilePicked) {
              setError("No file attached");
            } else if (!printDate) {
              setError("No Print Date filled");
            }

            if (isFilePicked && oen && printDate) {
              const result = await modifyPdf({ oen, printDate, selectedFile, fileBinary, canvasRef, setStatus, setError });
              console.log(result)
              setUuidValue(result)
            }
          }}
        >
          Upload Transcript
        </button>
        {error && <p className="mt-4 text-red-600	">{error}</p>}
        {status && <p className="mt-4 text-green-600">File was successfully uploaded as {uuidValue}.pdf and watermarked with unique identifier. Use tools below to download modified file. </p> }
      </form>
  );
}

export default FileUploader;
